import React from 'react';
import { Box, LinearProgress, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useColorMode } from 'src/theme/ThemeProvider';

interface MessageProgressProps {
  progress: number;
}

const MessageProgress: React.FC<MessageProgressProps> = ({ progress }) => {
  const theme = useTheme();
  const { mode } = useColorMode();
  const isDarkMode = mode === 'dark';

  return (
    <Box sx={{ width: '100%', mt: 1 }}>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: isDarkMode
            ? alpha(theme.palette.common.white, 0.1)
            : alpha(theme.palette.grey[300], 0.6),
          '& .MuiLinearProgress-bar': {
            borderRadius: 4,
            backgroundImage: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          },
        }}
      />
      <Typography
        variant="caption"
        sx={{
          display: 'block',
          textAlign: 'center',
          mt: 0.5,
          color: isDarkMode ? theme.palette.text.secondary : theme.palette.text.primary,
        }}
      >
        {progress}%
      </Typography>
    </Box>
  );
};

export default MessageProgress; 
